import React from "react";
import { SwitchRoute } from "../../../Components/Route/SwitchRoute";
import {
  AgentCommissionRoutes,
  NewAgentCommissionRoutes,
} from "../../../routes";
import { useLayoutDetection } from "../../../Hooks";

export function AgentCommissionLayout() {
  const { isNewLayout } = useLayoutDetection();
  const routes = isNewLayout ? NewAgentCommissionRoutes : AgentCommissionRoutes;
  return <SwitchRoute routes={routes} />;
}
